import React, { useCallback, useImperativeHandle } from 'react';
import { OrderedSet } from 'immutable';
import type { ColDef } from 'ag-grid-community';
import { isServiceColumn } from 'components/AgGrid/helpers';
import { generatePath } from 'react-router-dom';
import ROUTES_PATH from 'domain/router/routesPathConfig';
import Api from 'domain/api';

type UsePropagateGridApiRefProps = {
  ref: React.Ref<unknown>;
  gridApiRef: React.MutableRefObject<any>;
  gridContext: Record<string, any>;
  selectedIDs: OrderedSet<string>;
};

// TODO NEED CHANGE FOR PAY MODULE
const usePropagateGridApiRef = (props: UsePropagateGridApiRefProps) => {
  const { ref, gridApiRef, gridContext, selectedIDs } = props;

  const exportAs = useCallback(
    async (format = 'csv', onlySelected = false) => {
      const { filter, sort } = gridApiRef.current.getState();
      const allColumns = gridApiRef.current?.getAllDisplayedColumns() || [];
      // for deep column data like warning we have naming(path to value) warning.status, so that we can immediately take desired value
      // send to back-end origin column id colId.split('.')[0] - warning
      const columnKeys = allColumns
        .filter(({ colId }: { colId: string }) => !isServiceColumn(colId))
        .map(({ colId, colDef }: { colId: string; colDef: ColDef }) => ({
          field: colId.split('.')[0],
          headerName: colDef.headerName,
          type: colDef.type,
        }));
      try {
        const {
          data: { task_id: taskId },
        } = await Api.gridDocumentsExport({
          data: {
            format,
            headers: columnKeys,
            document_ids: onlySelected ? selectedIDs.toList() : [],
            filters: {
              filterModel: filter?.filterModel || {},
              sortModel: sort?.sortModel || [],
              ...gridContext.fetchParams,
            },
          },
        });

        const path = generatePath(ROUTES_PATH.DEFERRED_TASK.absolute, { taskId });
        const params = new URLSearchParams({ type: 'workspaceExport' });
        const url = `${path}?${params}`;

        window.open(url, '_blank');
      } catch (e) {
        console.error(e);
      }
    },
    [gridApiRef, gridContext, selectedIDs],
  );

  useImperativeHandle(ref, () => ({
    exportAllRowsDataAsExcel: () => exportAs('xls'),
    exportSelectedRowsDataAsExcel: () => exportAs('xls', true),
    exportAllRowsDataAsCsv: () => exportAs(),
  }));
};

export default usePropagateGridApiRef;
